"use strict";

exports.__esModule = true;
exports.useDispatch = exports.useDebounce = exports.useClickOutside = exports.useApplication = exports.debounce = exports.WindowResizeController = exports.WindowFocusController = exports.VisibilityController = exports.UseWindowFocus = exports.UseVisibility = exports.UseTargetMutation = exports.UseMutation = exports.UseHover = exports.TransitionController = exports.TargetMutationController = exports.ResizeController = exports.MutationController = exports.LazyLoadController = exports.IntersectionController = exports.IdleController = exports.HoverController = exports.ClickOutsideController = exports.ApplicationController = void 0;
exports.useHotkeys = useHotkeys;
exports.useWindowResize = exports.useWindowFocus = exports.useVisibility = exports.useTransition = exports.useThrottle = exports.useTargetMutation = exports.useResize = exports.useMutation = exports.useMeta = exports.useMemo = exports.useMatchMedia = exports.useLazyLoad = exports.useIntersection = exports.useIdle = exports.useHover = void 0;
var _stimulus = require("@hotwired/stimulus");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); } /*
 * stimulus-use 0.52.2
 */
var method = function method(controller, methodName) {
  var method = controller[methodName];
  if (typeof method == "function") {
    return method;
  } else {
    return function () {};
  }
};
var composeEventName = function composeEventName(name, controller, eventPrefix) {
  var composedName = name;
  if (eventPrefix === true) {
    composedName = "".concat(controller.identifier, ":").concat(name);
  } else if (typeof eventPrefix === "string") {
    composedName = "".concat(eventPrefix, ":").concat(name);
  }
  return composedName;
};
var extendedEvent = function extendedEvent(type, event, detail) {
  var _ref = event || {
      bubbles: true,
      cancelable: true,
      composed: true
    },
    bubbles = _ref.bubbles,
    cancelable = _ref.cancelable,
    composed = _ref.composed;
  if (event) {
    Object.assign(detail, {
      originalEvent: event
    });
  }
  var customEvent = new CustomEvent(type, {
    bubbles: bubbles,
    cancelable: cancelable,
    composed: composed,
    detail: detail
  });
  return customEvent;
};
function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  var windowHeight = window.innerHeight || document.documentElement.clientHeight;
  var windowWidth = window.innerWidth || document.documentElement.clientWidth;
  var vertInView = rect.top <= windowHeight && rect.top + rect.height > 0;
  var horInView = rect.left <= windowWidth && rect.left + rect.width > 0;
  return vertInView && horInView;
}
function camelize(value) {
  return value.replace(/(?:[_-])([a-z0-9])/g, function (_, char) {
    return char.toUpperCase();
  });
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
var defaultOptions$8 = {
  debug: false,
  logger: console,
  dispatchEvent: true,
  eventPrefix: true
};
var StimulusUse = /*#__PURE__*/_createClass(function StimulusUse(controller) {
  var _this = this;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  _classCallCheck(this, StimulusUse);
  var _a, _b, _c;
  this.log = function (functionName, args) {
    if (!_this.debug) return;
    _this.logger.groupCollapsed("%c".concat(_this.controller.identifier, " %c#").concat(functionName), "color: #3B82F6", "color: unset");
    _this.logger.log(Object.assign({
      controllerId: _this.controllerId
    }, args));
    _this.logger.groupEnd();
  };
  this.warn = function (message) {
    _this.logger.warn("%c".concat(_this.controller.identifier, " %c").concat(message), "color: #3B82F6; font-weight: bold", "color: unset");
  };
  this.dispatch = function (eventName) {
    var details = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (_this.dispatchEvent) {
      var event = details.event,
        eventDetails = __rest(details, ["event"]);
      var customEvent = _this.extendedEvent(eventName, event || null, eventDetails);
      _this.targetElement.dispatchEvent(customEvent);
      _this.log("dispatchEvent", Object.assign({
        eventName: customEvent.type
      }, eventDetails));
    }
  };
  this.call = function (methodName) {
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var method = _this.controller[methodName];
    if (typeof method == "function") {
      return method.call(_this.controller, args);
    }
  };
  this.extendedEvent = function (name, event, detail) {
    var _ref2 = event || {
        bubbles: true,
        cancelable: true,
        composed: true
      },
      bubbles = _ref2.bubbles,
      cancelable = _ref2.cancelable,
      composed = _ref2.composed;
    if (event) {
      Object.assign(detail, {
        originalEvent: event
      });
    }
    var customEvent = new CustomEvent(_this.composeEventName(name), {
      bubbles: bubbles,
      cancelable: cancelable,
      composed: composed,
      detail: detail
    });
    return customEvent;
  };
  this.composeEventName = function (name) {
    var composedName = name;
    if (_this.eventPrefix === true) {
      composedName = "".concat(_this.controller.identifier, ":").concat(name);
    } else if (typeof _this.eventPrefix === "string") {
      composedName = "".concat(_this.eventPrefix, ":").concat(name);
    }
    return composedName;
  };
  this.debug = (_b = (_a = options === null || options === void 0 ? void 0 : options.debug) !== null && _a !== void 0 ? _a : controller.application.stimulusUseDebug) !== null && _b !== void 0 ? _b : defaultOptions$8.debug;
  this.logger = (_c = options === null || options === void 0 ? void 0 : options.logger) !== null && _c !== void 0 ? _c : defaultOptions$8.logger;
  this.controller = controller;
  this.controllerId = controller.element.id || controller.element.dataset.id;
  this.targetElement = (options === null || options === void 0 ? void 0 : options.element) || controller.element;
  var _Object$assign = Object.assign({}, defaultOptions$8, options),
    dispatchEvent = _Object$assign.dispatchEvent,
    eventPrefix = _Object$assign.eventPrefix;
  Object.assign(this, {
    dispatchEvent: dispatchEvent,
    eventPrefix: eventPrefix
  });
  this.controllerInitialize = controller.initialize.bind(controller);
  this.controllerConnect = controller.connect.bind(controller);
  this.controllerDisconnect = controller.disconnect.bind(controller);
});
var defaultOptions$7 = {
  eventPrefix: true,
  bubbles: true,
  cancelable: true
};
var UseDispatch = /*#__PURE__*/function (_StimulusUse) {
  function UseDispatch(controller) {
    var _this2;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, UseDispatch);
    var _a, _b, _c, _d;
    _this2 = _callSuper(this, UseDispatch, [controller, options]);
    _this2.dispatch = function (eventName) {
      var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this3 = _this2,
        controller = _this3.controller,
        targetElement = _this3.targetElement,
        eventPrefix = _this3.eventPrefix,
        bubbles = _this3.bubbles,
        cancelable = _this3.cancelable,
        log = _this3.log,
        warn = _this3.warn;
      Object.assign(detail, {
        controller: controller
      });
      var eventNameWithPrefix = composeEventName(eventName, _this2.controller, eventPrefix);
      var event = new CustomEvent(eventNameWithPrefix, {
        detail: detail,
        bubbles: bubbles,
        cancelable: cancelable
      });
      targetElement.dispatchEvent(event);
      warn("`useDispatch()` is deprecated. Please use the built-in `this.dispatch()` function from Stimulus. You can find more information on how to upgrade at: https://stimulus-use.github.io/stimulus-use/#/use-dispatch");
      log("dispatch", {
        eventName: eventNameWithPrefix,
        detail: detail,
        bubbles: bubbles,
        cancelable: cancelable
      });
      return event;
    };
    _this2.targetElement = (_a = options.element) !== null && _a !== void 0 ? _a : controller.element;
    _this2.eventPrefix = (_b = options.eventPrefix) !== null && _b !== void 0 ? _b : defaultOptions$7.eventPrefix;
    _this2.bubbles = (_c = options.bubbles) !== null && _c !== void 0 ? _c : defaultOptions$7.bubbles;
    _this2.cancelable = (_d = options.cancelable) !== null && _d !== void 0 ? _d : defaultOptions$7.cancelable;
    _this2.enhanceController();
    return _this2;
  }
  _inherits(UseDispatch, _StimulusUse);
  return _createClass(UseDispatch, [{
    key: "enhanceController",
    value: function enhanceController() {
      Object.assign(this.controller, {
        dispatch: this.dispatch
      });
    }
  }]);
}(StimulusUse);
var useDispatch = exports.useDispatch = function useDispatch(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new UseDispatch(controller, options);
};
var defaultOptions$6 = {
  overwriteDispatch: true
};
var useApplication = exports.useApplication = function useApplication(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _Object$assign2 = Object.assign({}, defaultOptions$6, options),
    overwriteDispatch = _Object$assign2.overwriteDispatch;
  Object.defineProperty(controller, "isPreview", {
    get: function get() {
      return document.documentElement.hasAttribute("data-turbolinks-preview") || document.documentElement.hasAttribute("data-turbo-preview");
    }
  });
  Object.defineProperty(controller, "isConnected", {
    get: function get() {
      var _this4 = this;
      return !!Array.from(this.context.module.connectedContexts).find(function (c) {
        return c === _this4.context;
      });
    }
  });
  Object.defineProperty(controller, "csrfToken", {
    get: function get() {
      return this.metaValue("csrf-token");
    }
  });
  if (overwriteDispatch) {
    useDispatch(controller, options);
  }
  Object.assign(controller, {
    metaValue: function metaValue(name) {
      var element = document.head.querySelector("meta[name=\"".concat(name, "\"]"));
      return element && element.getAttribute("content");
    }
  });
};
var ApplicationController = exports.ApplicationController = /*#__PURE__*/function (_Controller) {
  function ApplicationController(context) {
    var _this5;
    _classCallCheck(this, ApplicationController);
    _this5 = _callSuper(this, ApplicationController, [context]);
    _this5.isPreview = false;
    _this5.isConnected = false;
    _this5.csrfToken = "";
    useApplication(_this5, _this5.options);
    return _this5;
  }
  _inherits(ApplicationController, _Controller);
  return _createClass(ApplicationController);
}(_stimulus.Controller);
var defaultOptions$5 = {
  events: ["click", "touchend"],
  onlyVisible: true,
  dispatchEvent: true,
  eventPrefix: true
};
var useClickOutside = exports.useClickOutside = function useClickOutside(composableController) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var controller = composableController;
  var _Object$assign3 = Object.assign({}, defaultOptions$5, options),
    onlyVisible = _Object$assign3.onlyVisible,
    dispatchEvent = _Object$assign3.dispatchEvent,
    events = _Object$assign3.events,
    eventPrefix = _Object$assign3.eventPrefix;
  var onEvent = function onEvent(event) {
    var targetElement = (options === null || options === void 0 ? void 0 : options.element) || controller.element;
    if (targetElement.contains(event.target) || !isElementInViewport(targetElement) && onlyVisible) {
      return;
    }
    if (controller.clickOutside) {
      controller.clickOutside(event);
    }
    if (dispatchEvent) {
      var eventName = composeEventName("click:outside", controller, eventPrefix);
      var clickOutsideEvent = extendedEvent(eventName, event, {
        controller: controller
      });
      targetElement.dispatchEvent(clickOutsideEvent);
    }
  };
  var observe = function observe() {
    events === null || events === void 0 ? void 0 : events.forEach(function (event) {
      window.addEventListener(event, onEvent, true);
    });
  };
  var unobserve = function unobserve() {
    events === null || events === void 0 ? void 0 : events.forEach(function (event) {
      window.removeEventListener(event, onEvent, true);
    });
  };
  var controllerDisconnect = controller.disconnect.bind(controller);
  Object.assign(controller, {
    disconnect: function disconnect() {
      unobserve();
      controllerDisconnect();
    }
  });
  observe();
  return [observe, unobserve];
};
var ClickOutsideComposableController = /*#__PURE__*/function (_Controller2) {
  function ClickOutsideComposableController() {
    _classCallCheck(this, ClickOutsideComposableController);
    return _callSuper(this, ClickOutsideComposableController, arguments);
  }
  _inherits(ClickOutsideComposableController, _Controller2);
  return _createClass(ClickOutsideComposableController);
}(_stimulus.Controller);
var ClickOutsideController = exports.ClickOutsideController = /*#__PURE__*/function (_ClickOutsideComposab) {
  function ClickOutsideController(context) {
    var _this6;
    _classCallCheck(this, ClickOutsideController);
    _this6 = _callSuper(this, ClickOutsideController, [context]);
    requestAnimationFrame(function () {
      var _useClickOutside = useClickOutside(_this6, _this6.options),
        _useClickOutside2 = _slicedToArray(_useClickOutside, 2),
        observe = _useClickOutside2[0],
        unobserve = _useClickOutside2[1];
      Object.assign(_this6, {
        observe: observe,
        unobserve: unobserve
      });
    });
    return _this6;
  }
  _inherits(ClickOutsideController, _ClickOutsideComposab);
  return _createClass(ClickOutsideController);
}(ClickOutsideComposableController);
var DebounceController = /*#__PURE__*/function (_Controller3) {
  function DebounceController() {
    _classCallCheck(this, DebounceController);
    return _callSuper(this, DebounceController, arguments);
  }
  _inherits(DebounceController, _Controller3);
  return _createClass(DebounceController);
}(_stimulus.Controller);
DebounceController.debounces = [];
var defaultWait$1 = 200;
var debounce = exports.debounce = function debounce(fn) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultWait$1;
  var timeoutId = null;
  return function () {
    var args = Array.from(arguments);
    var context = this;
    var params = args.map(function (arg) {
      return arg.params;
    });
    var callback = function callback() {
      args.forEach(function (arg, index) {
        return arg.params = params[index];
      });
      return fn.apply(context, args);
    };
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(callback, wait);
  };
};
var useDebounce = exports.useDebounce = function useDebounce(composableController, options) {
  var controller = composableController;
  var constructor = controller.constructor;
  constructor.debounces.forEach(function (func) {
    if (typeof func === "string") {
      controller[func] = debounce(controller[func], options === null || options === void 0 ? void 0 : options.wait);
    }
    if (_typeof(func) === "object") {
      var name = func.name,
        wait = func.wait;
      if (!name) return;
      controller[name] = debounce(controller[name], wait || (options === null || options === void 0 ? void 0 : options.wait));
    }
  });
};
var UseHover = exports.UseHover = /*#__PURE__*/function (_StimulusUse2) {
  function UseHover(controller) {
    var _this7;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, UseHover);
    _this7 = _callSuper(this, UseHover, [controller, options]);
    _this7.observe = function () {
      _this7.targetElement.addEventListener("mouseenter", _this7.onEnter);
      _this7.targetElement.addEventListener("mouseleave", _this7.onLeave);
    };
    _this7.unobserve = function () {
      _this7.targetElement.removeEventListener("mouseenter", _this7.onEnter);
      _this7.targetElement.removeEventListener("mouseleave", _this7.onLeave);
    };
    _this7.onEnter = function (event) {
      _this7.call("mouseEnter", event);
      _this7.log("mouseEnter", {
        hover: true
      });
      _this7.dispatch("mouseEnter", {
        hover: false
      });
    };
    _this7.onLeave = function (event) {
      _this7.call("mouseLeave", event);
      _this7.log("mouseLeave", {
        hover: false
      });
      _this7.dispatch("mouseLeave", {
        hover: false
      });
    };
    _this7.controller = controller;
    _this7.enhanceController();
    _this7.observe();
    return _this7;
  }
  _inherits(UseHover, _StimulusUse2);
  return _createClass(UseHover, [{
    key: "enhanceController",
    value: function enhanceController() {
      var _this8 = this;
      var controllerDisconnect = this.controller.disconnect.bind(this.controller);
      var disconnect = function disconnect() {
        _this8.unobserve();
        controllerDisconnect();
      };
      Object.assign(this.controller, {
        disconnect: disconnect
      });
    }
  }]);
}(StimulusUse);
var useHover = exports.useHover = function useHover(composableController) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var controller = composableController;
  var observer = new UseHover(controller, options);
  return [observer.observe, observer.unobserve];
};
var HoverComposableController = /*#__PURE__*/function (_Controller4) {
  function HoverComposableController() {
    _classCallCheck(this, HoverComposableController);
    return _callSuper(this, HoverComposableController, arguments);
  }
  _inherits(HoverComposableController, _Controller4);
  return _createClass(HoverComposableController);
}(_stimulus.Controller);
var HoverController = exports.HoverController = /*#__PURE__*/function (_HoverComposableContr) {
  function HoverController(context) {
    var _this9;
    _classCallCheck(this, HoverController);
    _this9 = _callSuper(this, HoverController, [context]);
    requestAnimationFrame(function () {
      var _useHover = useHover(_this9, _this9.options),
        _useHover2 = _slicedToArray(_useHover, 2),
        observe = _useHover2[0],
        unobserve = _useHover2[1];
      Object.assign(_this9, {
        observe: observe,
        unobserve: unobserve
      });
    });
    return _this9;
  }
  _inherits(HoverController, _HoverComposableContr);
  return _createClass(HoverController);
}(HoverComposableController);
var defaultEvents = ["mousemove", "mousedown", "resize", "keydown", "touchstart", "wheel"];
var oneMinute = 6e4;
var defaultOptions$4 = {
  ms: oneMinute,
  initialState: false,
  events: defaultEvents,
  dispatchEvent: true,
  eventPrefix: true
};
var useIdle = exports.useIdle = function useIdle(composableController) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var controller = composableController;
  var _Object$assign4 = Object.assign({}, defaultOptions$4, options),
    ms = _Object$assign4.ms,
    initialState = _Object$assign4.initialState,
    events = _Object$assign4.events,
    dispatchEvent = _Object$assign4.dispatchEvent,
    eventPrefix = _Object$assign4.eventPrefix;
  var isIdle = initialState;
  var timeout = setTimeout(function () {
    isIdle = true;
    dispatchAway();
  }, ms);
  var dispatchAway = function dispatchAway(event) {
    var eventName = composeEventName("away", controller, eventPrefix);
    controller.isIdle = true;
    method(controller, "away").call(controller, event);
    if (dispatchEvent) {
      var clickOutsideEvent = extendedEvent(eventName, event || null, {
        controller: controller
      });
      controller.element.dispatchEvent(clickOutsideEvent);
    }
  };
  var dispatchBack = function dispatchBack(event) {
    var eventName = composeEventName("back", controller, eventPrefix);
    controller.isIdle = false;
    method(controller, "back").call(controller, event);
    if (dispatchEvent) {
      var clickOutsideEvent = extendedEvent(eventName, event || null, {
        controller: controller
      });
      controller.element.dispatchEvent(clickOutsideEvent);
    }
  };
  var onEvent = function onEvent(event) {
    if (isIdle) dispatchBack(event);
    isIdle = false;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      isIdle = true;
      dispatchAway(event);
    }, ms);
  };
  var onVisibility = function onVisibility(event) {
    if (!document.hidden) onEvent(event);
  };
  if (isIdle) {
    dispatchAway();
  } else {
    dispatchBack();
  }
  var controllerDisconnect = controller.disconnect.bind(controller);
  var observe = function observe() {
    events.forEach(function (event) {
      window.addEventListener(event, onEvent);
    });
    document.addEventListener("visibilitychange", onVisibility);
  };
  var unobserve = function unobserve() {
    clearTimeout(timeout);
    events.forEach(function (event) {
      window.removeEventListener(event, onEvent);
    });
    document.removeEventListener("visibilitychange", onVisibility);
  };
  Object.assign(controller, {
    disconnect: function disconnect() {
      unobserve();
      controllerDisconnect();
    }
  });
  observe();
  return [observe, unobserve];
};
var IdleComposableController = /*#__PURE__*/function (_Controller5) {
  function IdleComposableController() {
    var _this0;
    _classCallCheck(this, IdleComposableController);
    _this0 = _callSuper(this, IdleComposableController, arguments);
    _this0.isIdle = false;
    return _this0;
  }
  _inherits(IdleComposableController, _Controller5);
  return _createClass(IdleComposableController);
}(_stimulus.Controller);
var IdleController = exports.IdleController = /*#__PURE__*/function (_IdleComposableContro) {
  function IdleController(context) {
    var _this1;
    _classCallCheck(this, IdleController);
    _this1 = _callSuper(this, IdleController, [context]);
    requestAnimationFrame(function () {
      var _useIdle = useIdle(_this1, _this1.options),
        _useIdle2 = _slicedToArray(_useIdle, 2),
        observe = _useIdle2[0],
        unobserve = _useIdle2[1];
      Object.assign(_this1, {
        observe: observe,
        unobserve: unobserve
      });
    });
    return _this1;
  }
  _inherits(IdleController, _IdleComposableContro);
  return _createClass(IdleController);
}(IdleComposableController);
var defaultOptions$3 = {
  dispatchEvent: true,
  eventPrefix: true,
  visibleAttribute: "isVisible"
};
var useIntersection = exports.useIntersection = function useIntersection(composableController) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var controller = composableController;
  var _Object$assign5 = Object.assign({}, defaultOptions$3, options),
    dispatchEvent = _Object$assign5.dispatchEvent,
    eventPrefix = _Object$assign5.eventPrefix,
    visibleAttribute = _Object$assign5.visibleAttribute;
  var targetElement = (options === null || options === void 0 ? void 0 : options.element) || controller.element;
  if (!controller.intersectionElements) controller.intersectionElements = [];
  controller.intersectionElements.push(targetElement);
  var callback = function callback(entries) {
    var _entries = _slicedToArray(entries, 1),
      entry = _entries[0];
    if (entry.isIntersecting) {
      dispatchAppear(entry);
    } else if (targetElement.hasAttribute(visibleAttribute)) {
      dispatchDisappear(entry);
    }
  };
  var observer = new IntersectionObserver(callback, options);
  var dispatchAppear = function dispatchAppear(entry) {
    targetElement.setAttribute(visibleAttribute, "true");
    method(controller, "appear").call(controller, entry, observer);
    if (dispatchEvent) {
      var eventName = composeEventName("appear", controller, eventPrefix);
      var appearEvent = extendedEvent(eventName, null, {
        controller: controller,
        entry: entry,
        observer: observer
      });
      targetElement.dispatchEvent(appearEvent);
    }
  };
  var dispatchDisappear = function dispatchDisappear(entry) {
    targetElement.removeAttribute(visibleAttribute);
    method(controller, "disappear").call(controller, entry, observer);
    if (dispatchEvent) {
      var eventName = composeEventName("disappear", controller, eventPrefix);
      var disappearEvent = extendedEvent(eventName, null, {
        controller: controller,
        entry: entry,
        observer: observer
      });
      targetElement.dispatchEvent(disappearEvent);
    }
  };
  var controllerDisconnect = controller.disconnect.bind(controller);
  var disconnect = function disconnect() {
    unobserve();
    controllerDisconnect();
  };
  var observe = function observe() {
    observer.observe(targetElement);
  };
  var unobserve = function unobserve() {
    observer.unobserve(targetElement);
  };
  var noneVisible = function noneVisible() {
    return controller.intersectionElements.filter(function (element) {
      return element.hasAttribute(visibleAttribute);
    }).length === 0;
  };
  var oneVisible = function oneVisible() {
    return controller.intersectionElements.filter(function (element) {
      return element.hasAttribute(visibleAttribute);
    }).length === 1;
  };
  var atLeastOneVisible = function atLeastOneVisible() {
    return controller.intersectionElements.some(function (element) {
      return element.hasAttribute(visibleAttribute);
    });
  };
  var allVisible = function allVisible() {
    return controller.intersectionElements.every(function (element) {
      return element.hasAttribute(visibleAttribute);
    });
  };
  var isVisible = allVisible;
  Object.assign(controller, {
    isVisible: isVisible,
    noneVisible: noneVisible,
    oneVisible: oneVisible,
    atLeastOneVisible: atLeastOneVisible,
    allVisible: allVisible,
    disconnect: disconnect
  });
  observe();
  return [observe, unobserve];
};
var IntersectionComposableController = /*#__PURE__*/function (_Controller6) {
  function IntersectionComposableController() {
    _classCallCheck(this, IntersectionComposableController);
    return _callSuper(this, IntersectionComposableController, arguments);
  }
  _inherits(IntersectionComposableController, _Controller6);
  return _createClass(IntersectionComposableController);
}(_stimulus.Controller);
var IntersectionController = exports.IntersectionController = /*#__PURE__*/function (_IntersectionComposab) {
  function IntersectionController(context) {
    var _this10;
    _classCallCheck(this, IntersectionController);
    _this10 = _callSuper(this, IntersectionController, [context]);
    requestAnimationFrame(function () {
      var _useIntersection = useIntersection(_this10, _this10.options),
        _useIntersection2 = _slicedToArray(_useIntersection, 2),
        observe = _useIntersection2[0],
        unobserve = _useIntersection2[1];
      Object.assign(_this10, {
        observe: observe,
        unobserve: unobserve
      });
    });
    return _this10;
  }
  _inherits(IntersectionController, _IntersectionComposab);
  return _createClass(IntersectionController);
}(IntersectionComposableController);
var useLazyLoad = exports.useLazyLoad = function useLazyLoad(controller, options) {
  var callback = function callback(entries) {
    var _entries2 = _slicedToArray(entries, 1),
      entry = _entries2[0];
    if (entry.isIntersecting && !controller.isLoaded) {
      handleAppear();
    }
  };
  var handleAppear = function handleAppear(entry) {
    var src = controller.data.get("src");
    if (!src) return;
    var imageElement = controller.element;
    controller.isLoading = true;
    method(controller, "loading").call(controller, src);
    imageElement.onload = function () {
      handleLoaded(src);
    };
    imageElement.src = src;
  };
  var handleLoaded = function handleLoaded(src) {
    controller.isLoading = false;
    controller.isLoaded = true;
    method(controller, "loaded").call(controller, src);
  };
  var controllerDisconnect = controller.disconnect.bind(controller);
  var observer = new IntersectionObserver(callback, options);
  var observe = function observe() {
    observer.observe(controller.element);
  };
  var unobserve = function unobserve() {
    observer.unobserve(controller.element);
  };
  Object.assign(controller, {
    isVisible: false,
    disconnect: function disconnect() {
      unobserve();
      controllerDisconnect();
    }
  });
  observe();
  return [observe, unobserve];
};
var LazyLoadComposableController = /*#__PURE__*/function (_Controller7) {
  function LazyLoadComposableController() {
    var _this11;
    _classCallCheck(this, LazyLoadComposableController);
    _this11 = _callSuper(this, LazyLoadComposableController, arguments);
    _this11.isLoading = false;
    _this11.isLoaded = false;
    return _this11;
  }
  _inherits(LazyLoadComposableController, _Controller7);
  return _createClass(LazyLoadComposableController);
}(_stimulus.Controller);
var LazyLoadController = exports.LazyLoadController = /*#__PURE__*/function (_LazyLoadComposableCo) {
  function LazyLoadController(context) {
    var _this12;
    _classCallCheck(this, LazyLoadController);
    _this12 = _callSuper(this, LazyLoadController, [context]);
    _this12.options = {
      rootMargin: "10%"
    };
    requestAnimationFrame(function () {
      var _useLazyLoad = useLazyLoad(_this12, _this12.options),
        _useLazyLoad2 = _slicedToArray(_useLazyLoad, 2),
        observe = _useLazyLoad2[0],
        unobserve = _useLazyLoad2[1];
      Object.assign(_this12, {
        observe: observe,
        unobserve: unobserve
      });
    });
    return _this12;
  }
  _inherits(LazyLoadController, _LazyLoadComposableCo);
  return _createClass(LazyLoadController);
}(LazyLoadComposableController);
var defaultOptions$2 = {
  mediaQueries: {},
  dispatchEvent: true,
  eventPrefix: true,
  debug: false
};
var UseMatchMedia = /*#__PURE__*/function (_StimulusUse3) {
  function UseMatchMedia(controller) {
    var _this13;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, UseMatchMedia);
    var _a, _b, _c, _d;
    _this13 = _callSuper(this, UseMatchMedia, [controller, options]);
    _this13.matches = [];
    _this13.callback = function (event) {
      var name = Object.keys(_this13.mediaQueries).find(function (name) {
        return _this13.mediaQueries[name] === event.media;
      });
      if (!name) return;
      var media = event.media,
        matches = event.matches;
      _this13.changed({
        name: name,
        media: media,
        matches: matches,
        event: event
      });
    };
    _this13.changed = function (payload) {
      var name = payload.name;
      if (payload.event) {
        _this13.call(camelize("".concat(name, "_changed")), payload);
        _this13.dispatch("".concat(name, ":changed"), payload);
        _this13.log("media query \"".concat(name, "\" changed"), payload);
      }
      if (payload.matches) {
        _this13.call(camelize("is_".concat(name)), payload);
        _this13.dispatch("is:".concat(name), payload);
      } else {
        _this13.call(camelize("not_".concat(name)), payload);
        _this13.dispatch("not:".concat(name), payload);
      }
    };
    _this13.observe = function () {
      Object.keys(_this13.mediaQueries).forEach(function (name) {
        var media = _this13.mediaQueries[name];
        var match = window.matchMedia(media);
        match.addListener(_this13.callback);
        _this13.matches.push(match);
        _this13.changed({
          name: name,
          media: media,
          matches: match.matches
        });
      });
    };
    _this13.unobserve = function () {
      _this13.matches.forEach(function (match) {
        return match.removeListener(_this13.callback);
      });
    };
    _this13.controller = controller;
    _this13.mediaQueries = (_a = options.mediaQueries) !== null && _a !== void 0 ? _a : defaultOptions$2.mediaQueries;
    _this13.dispatchEvent = (_b = options.dispatchEvent) !== null && _b !== void 0 ? _b : defaultOptions$2.dispatchEvent;
    _this13.eventPrefix = (_c = options.eventPrefix) !== null && _c !== void 0 ? _c : defaultOptions$2.eventPrefix;
    _this13.debug = (_d = options.debug) !== null && _d !== void 0 ? _d : defaultOptions$2.debug;
    if (!window.matchMedia) {
      console.error("window.matchMedia() is not available");
      return _possibleConstructorReturn(_this13);
    }
    _this13.enhanceController();
    _this13.observe();
    return _this13;
  }
  _inherits(UseMatchMedia, _StimulusUse3);
  return _createClass(UseMatchMedia, [{
    key: "enhanceController",
    value: function enhanceController() {
      var _this14 = this;
      var controllerDisconnect = this.controller.disconnect.bind(this.controller);
      var disconnect = function disconnect() {
        _this14.unobserve();
        controllerDisconnect();
      };
      Object.assign(this.controller, {
        disconnect: disconnect
      });
    }
  }]);
}(StimulusUse);
var useMatchMedia = exports.useMatchMedia = function useMatchMedia(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var observer = new UseMatchMedia(controller, options);
  return [observer.observe, observer.unobserve];
};
var memoize = function memoize(controller, name, value) {
  Object.defineProperty(controller, name, {
    value: value
  });
  return value;
};
var useMemo = exports.useMemo = function useMemo(controller) {
  var _a;
  (_a = controller.constructor.memos) === null || _a === void 0 ? void 0 : _a.forEach(function (getter) {
    memoize(controller, getter, controller[getter]);
  });
};
var defineMetaGetter = function defineMetaGetter(controller, metaName, suffix) {
  var getterName = suffix ? "".concat(camelize(metaName), "Meta") : camelize(metaName);
  Object.defineProperty(controller, getterName, {
    get: function get() {
      return typeCast(metaValue(metaName));
    }
  });
};
function metaValue(name) {
  var element = document.head.querySelector("meta[name=\"".concat(name, "\"]"));
  return element && element.getAttribute("content");
}
function typeCast(value) {
  try {
    return JSON.parse(value);
  } catch (o_O) {
    return value;
  }
}
var useMeta = exports.useMeta = function useMeta(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    suffix: true
  };
  var metaNames = controller.constructor.metaNames;
  var suffix = options.suffix;
  metaNames === null || metaNames === void 0 ? void 0 : metaNames.forEach(function (metaName) {
    defineMetaGetter(controller, metaName, suffix);
  });
  Object.defineProperty(controller, "metas", {
    get: function get() {
      var result = {};
      metaNames === null || metaNames === void 0 ? void 0 : metaNames.forEach(function (metaName) {
        var value = typeCast(metaValue(metaName));
        if (value !== undefined && value !== null) {
          result[camelize(metaName)] = value;
        }
      });
      return result;
    }
  });
};
var UseMutation = exports.UseMutation = /*#__PURE__*/function (_StimulusUse4) {
  function UseMutation(controller) {
    var _this15;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, UseMutation);
    _this15 = _callSuper(this, UseMutation, [controller, options]);
    _this15.observe = function () {
      try {
        _this15.observer.observe(_this15.targetElement, _this15.options);
      } catch (error) {
        _this15.controller.application.handleError(error, "At a minimum, one of childList, attributes, and/or characterData must be true", {});
      }
    };
    _this15.unobserve = function () {
      _this15.observer.disconnect();
    };
    _this15.mutation = function (entries) {
      _this15.call("mutate", entries);
      _this15.log("mutate", {
        entries: entries
      });
      _this15.dispatch("mutate", {
        entries: entries
      });
    };
    _this15.targetElement = (options === null || options === void 0 ? void 0 : options.element) || controller.element;
    _this15.controller = controller;
    _this15.options = options;
    _this15.observer = new MutationObserver(_this15.mutation);
    _this15.enhanceController();
    _this15.observe();
    return _this15;
  }
  _inherits(UseMutation, _StimulusUse4);
  return _createClass(UseMutation, [{
    key: "enhanceController",
    value: function enhanceController() {
      var _this16 = this;
      var controllerDisconnect = this.controller.disconnect.bind(this.controller);
      var disconnect = function disconnect() {
        _this16.unobserve();
        controllerDisconnect();
      };
      Object.assign(this.controller, {
        disconnect: disconnect
      });
    }
  }]);
}(StimulusUse);
var useMutation = exports.useMutation = function useMutation(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var observer = new UseMutation(controller, options);
  return [observer.observe, observer.unobserve];
};
var MutationComposableController = /*#__PURE__*/function (_Controller8) {
  function MutationComposableController() {
    _classCallCheck(this, MutationComposableController);
    return _callSuper(this, MutationComposableController, arguments);
  }
  _inherits(MutationComposableController, _Controller8);
  return _createClass(MutationComposableController);
}(_stimulus.Controller);
var MutationController = exports.MutationController = /*#__PURE__*/function (_MutationComposableCo) {
  function MutationController(context) {
    var _this17;
    _classCallCheck(this, MutationController);
    _this17 = _callSuper(this, MutationController, [context]);
    requestAnimationFrame(function () {
      var _useMutation = useMutation(_this17, _this17.options),
        _useMutation2 = _slicedToArray(_useMutation, 2),
        observe = _useMutation2[0],
        unobserve = _useMutation2[1];
      Object.assign(_this17, {
        observe: observe,
        unobserve: unobserve
      });
    });
    return _this17;
  }
  _inherits(MutationController, _MutationComposableCo);
  return _createClass(MutationController);
}(MutationComposableController);
var defaultOptions$1 = {
  dispatchEvent: true,
  eventPrefix: true
};
var useResize = exports.useResize = function useResize(composableController) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var controller = composableController;
  var _Object$assign6 = Object.assign({}, defaultOptions$1, options),
    dispatchEvent = _Object$assign6.dispatchEvent,
    eventPrefix = _Object$assign6.eventPrefix;
  var targetElement = (options === null || options === void 0 ? void 0 : options.element) || controller.element;
  var callback = function callback(entries) {
    var _entries3 = _slicedToArray(entries, 1),
      entry = _entries3[0];
    method(controller, "resize").call(controller, entry.contentRect);
    if (dispatchEvent) {
      var eventName = composeEventName("resize", controller, eventPrefix);
      var appearEvent = extendedEvent(eventName, null, {
        controller: controller,
        entry: entry
      });
      targetElement.dispatchEvent(appearEvent);
    }
  };
  var controllerDisconnect = controller.disconnect.bind(controller);
  var observer = new ResizeObserver(callback);
  var observe = function observe() {
    observer.observe(targetElement);
  };
  var unobserve = function unobserve() {
    observer.unobserve(targetElement);
  };
  Object.assign(controller, {
    disconnect: function disconnect() {
      unobserve();
      controllerDisconnect();
    }
  });
  observe();
  return [observe, unobserve];
};
var ResizeComposableController = /*#__PURE__*/function (_Controller9) {
  function ResizeComposableController() {
    _classCallCheck(this, ResizeComposableController);
    return _callSuper(this, ResizeComposableController, arguments);
  }
  _inherits(ResizeComposableController, _Controller9);
  return _createClass(ResizeComposableController);
}(_stimulus.Controller);
var ResizeController = exports.ResizeController = /*#__PURE__*/function (_ResizeComposableCont) {
  function ResizeController(context) {
    var _this18;
    _classCallCheck(this, ResizeController);
    _this18 = _callSuper(this, ResizeController, [context]);
    requestAnimationFrame(function () {
      var _useResize = useResize(_this18, _this18.options),
        _useResize2 = _slicedToArray(_useResize, 2),
        observe = _useResize2[0],
        unobserve = _useResize2[1];
      Object.assign(_this18, {
        observe: observe,
        unobserve: unobserve
      });
    });
    return _this18;
  }
  _inherits(ResizeController, _ResizeComposableCont);
  return _createClass(ResizeController);
}(ResizeComposableController);
var UseTargetMutation = exports.UseTargetMutation = /*#__PURE__*/function (_StimulusUse5) {
  function UseTargetMutation(controller) {
    var _this19;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, UseTargetMutation);
    _this19 = _callSuper(this, UseTargetMutation, [controller, options]);
    _this19.observe = function () {
      _this19.observer.observe(_this19.targetElement, {
        subtree: true,
        characterData: true,
        childList: true,
        attributes: true,
        attributeOldValue: true,
        attributeFilter: [_this19.targetSelector, _this19.scopedTargetSelector]
      });
    };
    _this19.unobserve = function () {
      _this19.observer.disconnect();
    };
    _this19.mutation = function (entries) {
      var _iterator = _createForOfIteratorHelper(entries),
        _step;
      try {
        var _loop = function _loop() {
            var mutation = _step.value;
            switch (mutation.type) {
              case "attributes":
                var newValue = mutation.target.getAttribute(mutation.attributeName);
                var oldValue = mutation.oldValue;
                if (mutation.attributeName === _this19.targetSelector || mutation.attributeName === _this19.scopedTargetSelector) {
                  var oldTargets = _this19.targetsUsedByThisController(oldValue);
                  var newTargets = _this19.targetsUsedByThisController(newValue);
                  var removedTargets = oldTargets.filter(function (target) {
                    return !newTargets.includes(target);
                  });
                  var addedTargets = newTargets.filter(function (target) {
                    return !oldTargets.includes(target);
                  });
                  removedTargets.forEach(function (target) {
                    return _this19.targetRemoved(_this19.stripIdentifierPrefix(target), mutation.target, "attributeChange");
                  });
                  addedTargets.forEach(function (target) {
                    return _this19.targetAdded(_this19.stripIdentifierPrefix(target), mutation.target, "attributeChange");
                  });
                }
                break;
              case "characterData":
                var nodule = _this19.findTargetInAncestry(mutation.target);
                if (nodule == null) {
                  return {
                    v: void 0
                  };
                } else {
                  var supportedTargets = _this19.targetsUsedByThisControllerFromNode(nodule);
                  supportedTargets.forEach(function (target) {
                    _this19.targetChanged(_this19.stripIdentifierPrefix(target), nodule, "domMutation");
                  });
                }
                break;
              case "childList":
                var addedNodes = mutation.addedNodes,
                  removedNodes = mutation.removedNodes;
                addedNodes.forEach(function (node) {
                  return _this19.processNodeDOMMutation(node, _this19.targetAdded);
                });
                removedNodes.forEach(function (node) {
                  return _this19.processNodeDOMMutation(node, _this19.targetRemoved);
                });
                break;
            }
          },
          _ret;
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _ret = _loop();
          if (_ret) return _ret.v;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };
    _this19.controller = controller;
    _this19.options = options;
    _this19.targetElement = controller.element;
    _this19.identifier = controller.scope.identifier;
    _this19.identifierPrefix = "".concat(_this19.identifier, ".");
    _this19.targetSelector = controller.scope.schema.targetAttribute;
    _this19.scopedTargetSelector = "data-".concat(_this19.identifier, "-target");
    _this19.targets = options.targets || controller.constructor.targets;
    _this19.prefixedTargets = _this19.targets.map(function (target) {
      return "".concat(_this19.identifierPrefix).concat(target);
    });
    _this19.observer = new MutationObserver(_this19.mutation);
    _this19.enhanceController();
    _this19.observe();
    return _this19;
  }
  _inherits(UseTargetMutation, _StimulusUse5);
  return _createClass(UseTargetMutation, [{
    key: "processNodeDOMMutation",
    value: function processNodeDOMMutation(node, initialChangeModeAssumption) {
      var _this20 = this;
      var nodule = node;
      var change = initialChangeModeAssumption;
      var supportedTargets = [];
      if (nodule.nodeName == "#text" || this.targetsUsedByThisControllerFromNode(nodule).length == 0) {
        change = this.targetChanged;
        nodule = this.findTargetInAncestry(node);
      } else {
        supportedTargets = this.targetsUsedByThisControllerFromNode(nodule);
      }
      if (nodule == null) {
        return;
      } else if (supportedTargets.length == 0) {
        supportedTargets = this.targetsUsedByThisControllerFromNode(nodule);
      }
      supportedTargets.forEach(function (target) {
        change.call(_this20, _this20.stripIdentifierPrefix(target), nodule, "domMutation");
      });
    }
  }, {
    key: "findTargetInAncestry",
    value: function findTargetInAncestry(node) {
      var nodule = node;
      var supportedTargets = [];
      if (nodule.nodeName != "#text") {
        supportedTargets = this.targetsUsedByThisControllerFromNode(nodule);
      }
      while (nodule.parentNode !== null && nodule.parentNode != this.targetElement && supportedTargets.length == 0) {
        nodule = nodule.parentNode;
        if (nodule.nodeName !== "#text") {
          var _supportedTargets = this.targetsUsedByThisControllerFromNode(nodule);
          if (_supportedTargets.length > 0) {
            return nodule;
          }
        }
      }
      if (nodule.nodeName == "#text") {
        return null;
      }
      if (nodule.parentNode == null) {
        return null;
      }
      if (nodule.parentNode == this.targetElement) {
        if (this.targetsUsedByThisControllerFromNode(nodule).length > 0) {
          return nodule;
        }
        return null;
      }
      return null;
    }
  }, {
    key: "targetAdded",
    value: function targetAdded(name, node, trigger) {
      var targetCallback = "".concat(name, "TargetAdded");
      this.controller[targetCallback] && method(this.controller, targetCallback).call(this.controller, node);
      this.warn("`[target]TargetAdded` is deprecated. Please use the built-in `[target]TargetConnected()` function from Stimulus.");
      this.log("targetAdded", {
        target: name,
        node: node,
        trigger: trigger
      });
    }
  }, {
    key: "targetRemoved",
    value: function targetRemoved(name, node, trigger) {
      var targetCallback = "".concat(name, "TargetRemoved");
      this.controller[targetCallback] && method(this.controller, targetCallback).call(this.controller, node);
      this.warn("`[target]TargetRemoved` is deprecated. Please use the built-in `[target]TargetDisconnected()` function from Stimulus.");
      this.log("targetRemoved", {
        target: name,
        node: node,
        trigger: trigger
      });
    }
  }, {
    key: "targetChanged",
    value: function targetChanged(name, node, trigger) {
      var targetCallback = "".concat(name, "TargetChanged");
      this.controller[targetCallback] && method(this.controller, targetCallback).call(this.controller, node);
      this.log("targetChanged", {
        target: name,
        node: node,
        trigger: trigger
      });
    }
  }, {
    key: "targetsUsedByThisControllerFromNode",
    value: function targetsUsedByThisControllerFromNode(node) {
      if (node.nodeName == "#text" || node.nodeName == "#comment") {
        return [];
      }
      var nodeElement = node;
      return this.targetsUsedByThisController(nodeElement.getAttribute(this.scopedTargetSelector) || nodeElement.getAttribute(this.targetSelector));
    }
  }, {
    key: "targetsUsedByThisController",
    value: function targetsUsedByThisController(targetStr) {
      targetStr = targetStr || "";
      var targetsToCheck = this.stripIdentifierPrefix(targetStr).split(" ");
      return this.targets.filter(function (n) {
        return targetsToCheck.indexOf(n) !== -1;
      });
    }
  }, {
    key: "stripIdentifierPrefix",
    value: function stripIdentifierPrefix(target) {
      return target.replace(new RegExp(this.identifierPrefix, "g"), "");
    }
  }, {
    key: "enhanceController",
    value: function enhanceController() {
      var _this21 = this;
      var controllerDisconnect = this.controller.disconnect.bind(this.controller);
      var disconnect = function disconnect() {
        _this21.unobserve();
        controllerDisconnect();
      };
      Object.assign(this.controller, {
        disconnect: disconnect
      });
    }
  }]);
}(StimulusUse);
var useTargetMutation = exports.useTargetMutation = function useTargetMutation(composableController) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var controller = composableController;
  var observer = new UseTargetMutation(controller, options);
  observer.warn("`[target]TargetAdded` and `[target]TargetRemoved` are deprecated. Please use the built-in `[target]TargetConnected()` and `[target]TargetDisconnected()` functions from Stimulus.");
  return [observer.observe, observer.unobserve];
};
var TargetMutationComposableController = /*#__PURE__*/function (_Controller0) {
  function TargetMutationComposableController() {
    _classCallCheck(this, TargetMutationComposableController);
    return _callSuper(this, TargetMutationComposableController, arguments);
  }
  _inherits(TargetMutationComposableController, _Controller0);
  return _createClass(TargetMutationComposableController);
}(_stimulus.Controller);
var TargetMutationController = exports.TargetMutationController = /*#__PURE__*/function (_TargetMutationCompos) {
  function TargetMutationController(context) {
    var _this22;
    _classCallCheck(this, TargetMutationController);
    _this22 = _callSuper(this, TargetMutationController, [context]);
    requestAnimationFrame(function () {
      var _useTargetMutation = useTargetMutation(_this22, _this22.options),
        _useTargetMutation2 = _slicedToArray(_useTargetMutation, 2),
        observe = _useTargetMutation2[0],
        unobserve = _useTargetMutation2[1];
      Object.assign(_this22, {
        observe: observe,
        unobserve: unobserve
      });
    });
    return _this22;
  }
  _inherits(TargetMutationController, _TargetMutationCompos);
  return _createClass(TargetMutationController);
}(TargetMutationComposableController);
var ThrottleController = /*#__PURE__*/function (_Controller1) {
  function ThrottleController() {
    _classCallCheck(this, ThrottleController);
    return _callSuper(this, ThrottleController, arguments);
  }
  _inherits(ThrottleController, _Controller1);
  return _createClass(ThrottleController);
}(_stimulus.Controller);
ThrottleController.throttles = [];
var defaultWait = 200;
function throttle(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultWait;
  var inThrottle;
  return function () {
    var args = arguments;
    var context = this;
    if (!inThrottle) {
      inThrottle = true;
      func.apply(context, args);
      setTimeout(function () {
        return inThrottle = false;
      }, wait);
    }
  };
}
var useThrottle = exports.useThrottle = function useThrottle(composableController) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _a;
  var controller = composableController;
  var constructor = controller.constructor;
  (_a = constructor.throttles) === null || _a === void 0 ? void 0 : _a.forEach(function (func) {
    if (typeof func === "string") {
      controller[func] = throttle(controller[func], options === null || options === void 0 ? void 0 : options.wait);
    }
    if (_typeof(func) === "object") {
      var name = func.name,
        wait = func.wait;
      if (!name) return;
      controller[name] = throttle(controller[name], wait || (options === null || options === void 0 ? void 0 : options.wait));
    }
  });
};
var alpineNames = {
  enterFromClass: "enter",
  enterActiveClass: "enterStart",
  enterToClass: "enterEnd",
  leaveFromClass: "leave",
  leaveActiveClass: "leaveStart",
  leaveToClass: "leaveEnd"
};
var defaultOptions = {
  transitioned: false,
  hiddenClass: "hidden",
  preserveOriginalClass: true,
  removeToClasses: true
};
var useTransition = exports.useTransition = function useTransition(composableController) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _a, _b, _c;
  var controller = composableController;
  var targetName = controller.element.dataset.transitionTarget;
  var targetFromAttribute;
  if (targetName) {
    targetFromAttribute = controller["".concat(targetName, "Target")];
  }
  var targetElement = (options === null || options === void 0 ? void 0 : options.element) || targetFromAttribute || controller.element;
  if (!(targetElement instanceof HTMLElement || targetElement instanceof SVGElement)) return;
  var dataset = targetElement.dataset;
  var leaveAfter = parseInt(dataset.leaveAfter || "") || options.leaveAfter || 0;
  var _Object$assign7 = Object.assign({}, defaultOptions, options),
    transitioned = _Object$assign7.transitioned,
    hiddenClass = _Object$assign7.hiddenClass,
    preserveOriginalClass = _Object$assign7.preserveOriginalClass,
    removeToClasses = _Object$assign7.removeToClasses;
  var controllerEnter = (_a = controller.enter) === null || _a === void 0 ? void 0 : _a.bind(controller);
  var controllerLeave = (_b = controller.leave) === null || _b === void 0 ? void 0 : _b.bind(controller);
  var controllerToggleTransition = (_c = controller.toggleTransition) === null || _c === void 0 ? void 0 : _c.bind(controller);
  function enter(_x) {
    return _enter.apply(this, arguments);
  }
  function _enter() {
    _enter = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
      var enterFromClasses, enterActiveClasses, enterToClasses, leaveToClasses;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!controller.transitioned) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            controller.transitioned = true;
            controllerEnter && controllerEnter(event);
            enterFromClasses = getAttribute("enterFrom", options, dataset);
            enterActiveClasses = getAttribute("enterActive", options, dataset);
            enterToClasses = getAttribute("enterTo", options, dataset);
            leaveToClasses = getAttribute("leaveTo", options, dataset);
            if (!!hiddenClass) {
              targetElement.classList.remove(hiddenClass);
            }
            if (!removeToClasses) {
              removeClasses(targetElement, leaveToClasses);
            }
            _context.n = 2;
            return transition(targetElement, enterFromClasses, enterActiveClasses, enterToClasses, hiddenClass, preserveOriginalClass, removeToClasses);
          case 2:
            if (leaveAfter > 0) {
              setTimeout(function () {
                leave(event);
              }, leaveAfter);
            }
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _enter.apply(this, arguments);
  }
  function leave(_x2) {
    return _leave.apply(this, arguments);
  }
  function _leave() {
    _leave = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(event) {
      var leaveFromClasses, leaveActiveClasses, leaveToClasses, enterToClasses;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            if (controller.transitioned) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2);
          case 1:
            controller.transitioned = false;
            controllerLeave && controllerLeave(event);
            leaveFromClasses = getAttribute("leaveFrom", options, dataset);
            leaveActiveClasses = getAttribute("leaveActive", options, dataset);
            leaveToClasses = getAttribute("leaveTo", options, dataset);
            enterToClasses = getAttribute("enterTo", options, dataset);
            if (!removeToClasses) {
              removeClasses(targetElement, enterToClasses);
            }
            _context2.n = 2;
            return transition(targetElement, leaveFromClasses, leaveActiveClasses, leaveToClasses, hiddenClass, preserveOriginalClass, removeToClasses);
          case 2:
            if (!!hiddenClass) {
              targetElement.classList.add(hiddenClass);
            }
          case 3:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return _leave.apply(this, arguments);
  }
  function toggleTransition(event) {
    controllerToggleTransition && controllerToggleTransition(event);
    if (controller.transitioned) {
      leave();
    } else {
      enter();
    }
  }
  function transition(_x3, _x4, _x5, _x6, _x7, _x8, _x9) {
    return _transition.apply(this, arguments);
  }
  function _transition() {
    _transition = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(element, initialClasses, activeClasses, endClasses, hiddenClass, preserveOriginalClass, removeEndClasses) {
      var stashedClasses;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            stashedClasses = [];
            if (preserveOriginalClass) {
              initialClasses.forEach(function (cls) {
                return element.classList.contains(cls) && cls !== hiddenClass && stashedClasses.push(cls);
              });
              activeClasses.forEach(function (cls) {
                return element.classList.contains(cls) && cls !== hiddenClass && stashedClasses.push(cls);
              });
              endClasses.forEach(function (cls) {
                return element.classList.contains(cls) && cls !== hiddenClass && stashedClasses.push(cls);
              });
            }
            addClasses(element, initialClasses);
            removeClasses(element, stashedClasses);
            addClasses(element, activeClasses);
            _context3.n = 1;
            return nextAnimationFrame();
          case 1:
            removeClasses(element, initialClasses);
            addClasses(element, endClasses);
            _context3.n = 2;
            return afterTransition(element);
          case 2:
            removeClasses(element, activeClasses);
            if (removeEndClasses) {
              removeClasses(element, endClasses);
            }
            addClasses(element, stashedClasses);
          case 3:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return _transition.apply(this, arguments);
  }
  function initialState() {
    controller.transitioned = transitioned;
    if (transitioned) {
      if (!!hiddenClass) {
        targetElement.classList.remove(hiddenClass);
      }
      enter();
    } else {
      if (!!hiddenClass) {
        targetElement.classList.add(hiddenClass);
      }
      leave();
    }
  }
  function addClasses(element, classes) {
    if (classes.length > 0) {
      var _element$classList;
      (_element$classList = element.classList).add.apply(_element$classList, _toConsumableArray(classes));
    }
  }
  function removeClasses(element, classes) {
    if (classes.length > 0) {
      var _element$classList2;
      (_element$classList2 = element.classList).remove.apply(_element$classList2, _toConsumableArray(classes));
    }
  }
  initialState();
  Object.assign(controller, {
    enter: enter,
    leave: leave,
    toggleTransition: toggleTransition
  });
  return [enter, leave, toggleTransition];
};
function getAttribute(name, options, dataset) {
  var datasetName = "transition".concat(name[0].toUpperCase()).concat(name.substr(1));
  var datasetAlpineName = alpineNames[name];
  var classes = options[name] || dataset[datasetName] || dataset[datasetAlpineName] || " ";
  return isEmpty(classes) ? [] : classes.split(" ");
}
function afterTransition(_x0) {
  return _afterTransition.apply(this, arguments);
}
function _afterTransition() {
  _afterTransition = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(element) {
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          return _context4.a(2, new Promise(function (resolve) {
            var duration = Number(getComputedStyle(element).transitionDuration.split(",")[0].replace("s", "")) * 1e3;
            setTimeout(function () {
              resolve(duration);
            }, duration);
          }));
      }
    }, _callee4);
  }));
  return _afterTransition.apply(this, arguments);
}
function nextAnimationFrame() {
  return _nextAnimationFrame.apply(this, arguments);
}
function _nextAnimationFrame() {
  _nextAnimationFrame = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          return _context5.a(2, new Promise(function (resolve) {
            requestAnimationFrame(function () {
              requestAnimationFrame(resolve);
            });
          }));
      }
    }, _callee5);
  }));
  return _nextAnimationFrame.apply(this, arguments);
}
function isEmpty(str) {
  return str.length === 0 || !str.trim();
}
var TransitionComposableController = /*#__PURE__*/function (_Controller10) {
  function TransitionComposableController() {
    var _this23;
    _classCallCheck(this, TransitionComposableController);
    _this23 = _callSuper(this, TransitionComposableController, arguments);
    _this23.transitioned = false;
    return _this23;
  }
  _inherits(TransitionComposableController, _Controller10);
  return _createClass(TransitionComposableController);
}(_stimulus.Controller);
var TransitionController = exports.TransitionController = /*#__PURE__*/function (_TransitionComposable) {
  function TransitionController(context) {
    var _this24;
    _classCallCheck(this, TransitionController);
    _this24 = _callSuper(this, TransitionController, [context]);
    requestAnimationFrame(function () {
      useTransition(_this24, _this24.options);
    });
    return _this24;
  }
  _inherits(TransitionController, _TransitionComposable);
  return _createClass(TransitionController);
}(TransitionComposableController);
var UseVisibility = exports.UseVisibility = /*#__PURE__*/function (_StimulusUse6) {
  function UseVisibility(controller) {
    var _this25;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, UseVisibility);
    _this25 = _callSuper(this, UseVisibility, [controller, options]);
    _this25.observe = function () {
      _this25.controller.isVisible = !document.hidden;
      document.addEventListener("visibilitychange", _this25.handleVisibilityChange);
      _this25.handleVisibilityChange();
    };
    _this25.unobserve = function () {
      document.removeEventListener("visibilitychange", _this25.handleVisibilityChange);
    };
    _this25.becomesInvisible = function (event) {
      _this25.controller.isVisible = false;
      _this25.call("invisible", event);
      _this25.log("invisible", {
        isVisible: false
      });
      _this25.dispatch("invisible", {
        event: event,
        isVisible: false
      });
    };
    _this25.becomesVisible = function (event) {
      _this25.controller.isVisible = true;
      _this25.call("visible", event);
      _this25.log("visible", {
        isVisible: true
      });
      _this25.dispatch("visible", {
        event: event,
        isVisible: true
      });
    };
    _this25.handleVisibilityChange = function (event) {
      if (document.hidden) {
        _this25.becomesInvisible(event);
      } else {
        _this25.becomesVisible(event);
      }
    };
    _this25.controller = controller;
    _this25.enhanceController();
    _this25.observe();
    return _this25;
  }
  _inherits(UseVisibility, _StimulusUse6);
  return _createClass(UseVisibility, [{
    key: "enhanceController",
    value: function enhanceController() {
      var _this26 = this;
      var controllerDisconnect = this.controllerDisconnect;
      var disconnect = function disconnect() {
        _this26.unobserve();
        controllerDisconnect();
      };
      Object.assign(this.controller, {
        disconnect: disconnect
      });
    }
  }]);
}(StimulusUse);
var useVisibility = exports.useVisibility = function useVisibility(composableController) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var controller = composableController;
  var observer = new UseVisibility(controller, options);
  return [observer.observe, observer.unobserve];
};
var VisibilityComposableController = /*#__PURE__*/function (_Controller11) {
  function VisibilityComposableController() {
    var _this27;
    _classCallCheck(this, VisibilityComposableController);
    _this27 = _callSuper(this, VisibilityComposableController, arguments);
    _this27.isVisible = false;
    return _this27;
  }
  _inherits(VisibilityComposableController, _Controller11);
  return _createClass(VisibilityComposableController);
}(_stimulus.Controller);
var VisibilityController = exports.VisibilityController = /*#__PURE__*/function (_VisibilityComposable) {
  function VisibilityController(context) {
    var _this28;
    _classCallCheck(this, VisibilityController);
    _this28 = _callSuper(this, VisibilityController, [context]);
    requestAnimationFrame(function () {
      var _useVisibility = useVisibility(_this28, _this28.options),
        _useVisibility2 = _slicedToArray(_useVisibility, 2),
        observe = _useVisibility2[0],
        unobserve = _useVisibility2[1];
      Object.assign(_this28, {
        observe: observe,
        unobserve: unobserve
      });
    });
    return _this28;
  }
  _inherits(VisibilityController, _VisibilityComposable);
  return _createClass(VisibilityController);
}(VisibilityComposableController);
var UseWindowFocus = exports.UseWindowFocus = /*#__PURE__*/function (_StimulusUse7) {
  function UseWindowFocus(controller) {
    var _this29;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, UseWindowFocus);
    _this29 = _callSuper(this, UseWindowFocus, [controller, options]);
    _this29.observe = function () {
      if (document.hasFocus()) {
        _this29.becomesFocused();
      } else {
        _this29.becomesUnfocused();
      }
      _this29.interval = setInterval(function () {
        _this29.handleWindowFocusChange();
      }, _this29.intervalDuration);
    };
    _this29.unobserve = function () {
      clearInterval(_this29.interval);
    };
    _this29.becomesUnfocused = function (event) {
      _this29.controller.hasFocus = false;
      _this29.call("unfocus", event);
      _this29.log("unfocus", {
        hasFocus: false
      });
      _this29.dispatch("unfocus", {
        event: event,
        hasFocus: false
      });
    };
    _this29.becomesFocused = function (event) {
      _this29.controller.hasFocus = true;
      _this29.call("focus", event);
      _this29.log("focus", {
        hasFocus: true
      });
      _this29.dispatch("focus", {
        event: event,
        hasFocus: true
      });
    };
    _this29.handleWindowFocusChange = function (event) {
      if (document.hasFocus() && !_this29.controller.hasFocus) {
        _this29.becomesFocused(event);
      } else if (!document.hasFocus() && _this29.controller.hasFocus) {
        _this29.becomesUnfocused(event);
      }
    };
    _this29.controller = controller;
    _this29.intervalDuration = options.interval || 200;
    _this29.enhanceController();
    _this29.observe();
    return _this29;
  }
  _inherits(UseWindowFocus, _StimulusUse7);
  return _createClass(UseWindowFocus, [{
    key: "enhanceController",
    value: function enhanceController() {
      var _this30 = this;
      var controllerDisconnect = this.controllerDisconnect;
      var disconnect = function disconnect() {
        _this30.unobserve();
        controllerDisconnect();
      };
      Object.assign(this.controller, {
        disconnect: disconnect
      });
    }
  }]);
}(StimulusUse);
var useWindowFocus = exports.useWindowFocus = function useWindowFocus(composableController) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var controller = composableController;
  var observer = new UseWindowFocus(controller, options);
  return [observer.observe, observer.unobserve];
};
var WindowFocusComposableController = /*#__PURE__*/function (_Controller12) {
  function WindowFocusComposableController() {
    var _this31;
    _classCallCheck(this, WindowFocusComposableController);
    _this31 = _callSuper(this, WindowFocusComposableController, arguments);
    _this31.hasFocus = false;
    return _this31;
  }
  _inherits(WindowFocusComposableController, _Controller12);
  return _createClass(WindowFocusComposableController);
}(_stimulus.Controller);
var WindowFocusController = exports.WindowFocusController = /*#__PURE__*/function (_WindowFocusComposabl) {
  function WindowFocusController(context) {
    var _this32;
    _classCallCheck(this, WindowFocusController);
    _this32 = _callSuper(this, WindowFocusController, [context]);
    requestAnimationFrame(function () {
      var _useWindowFocus = useWindowFocus(_this32, _this32.options),
        _useWindowFocus2 = _slicedToArray(_useWindowFocus, 2),
        observe = _useWindowFocus2[0],
        unobserve = _useWindowFocus2[1];
      Object.assign(_this32, {
        observe: observe,
        unobserve: unobserve
      });
    });
    return _this32;
  }
  _inherits(WindowFocusController, _WindowFocusComposabl);
  return _createClass(WindowFocusController);
}(WindowFocusComposableController);
var useWindowResize = exports.useWindowResize = function useWindowResize(composableController) {
  var controller = composableController;
  var callback = function callback(event) {
    var _window = window,
      innerWidth = _window.innerWidth,
      innerHeight = _window.innerHeight;
    var payload = {
      height: innerHeight || Infinity,
      width: innerWidth || Infinity,
      event: event
    };
    method(controller, "windowResize").call(controller, payload);
  };
  var controllerDisconnect = controller.disconnect.bind(controller);
  var observe = function observe() {
    window.addEventListener("resize", callback);
    callback();
  };
  var unobserve = function unobserve() {
    window.removeEventListener("resize", callback);
  };
  Object.assign(controller, {
    disconnect: function disconnect() {
      unobserve();
      controllerDisconnect();
    }
  });
  observe();
  return [observe, unobserve];
};
var WindowResizeComposableController = /*#__PURE__*/function (_Controller13) {
  function WindowResizeComposableController() {
    _classCallCheck(this, WindowResizeComposableController);
    return _callSuper(this, WindowResizeComposableController, arguments);
  }
  _inherits(WindowResizeComposableController, _Controller13);
  return _createClass(WindowResizeComposableController);
}(_stimulus.Controller);
var WindowResizeController = exports.WindowResizeController = /*#__PURE__*/function (_WindowResizeComposab) {
  function WindowResizeController(context) {
    var _this33;
    _classCallCheck(this, WindowResizeController);
    _this33 = _callSuper(this, WindowResizeController, [context]);
    requestAnimationFrame(function () {
      var _useWindowResize = useWindowResize(_this33),
        _useWindowResize2 = _slicedToArray(_useWindowResize, 2),
        observe = _useWindowResize2[0],
        unobserve = _useWindowResize2[1];
      Object.assign(_this33, {
        observe: observe,
        unobserve: unobserve
      });
    });
    return _this33;
  }
  _inherits(WindowResizeController, _WindowResizeComposab);
  return _createClass(WindowResizeController);
}(WindowResizeComposableController);
function useHotkeys() {
  throw "[stimulus-use] Notice: The import for `useHotkeys()` has been moved from `stimulus-use` to `stimulus-use/hotkeys`. \nPlease change the import accordingly and add `hotkey-js` as a dependency to your project. \n\nFor more information see: https://stimulus-use.github.io/stimulus-use/#/use-hotkeys?id=importing-the-behavior";
}